import React, { useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, ImageIcon } from 'lucide-react';
import { previews } from '../data/content';
import { OFFER_ANCHOR } from '../data/config';
export function ProductPreviewGallery() {
  const [index, setIndex] = useState(0);
  const dragged = useRef(false);
  const total = previews.length;
  const go = (dir: 1 | -1) => setIndex(i => (i + dir + total) % total);
  const slide = previews[index];
  return <section className="bg-white px-4 py-6 text-center md:px-12 md:py-7" data-id="element-120" data-mp="pwzfz97o2ayu">
      <h2 className="font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[32px]" data-id="element-121" data-mp="uuhtze0jjgdp">
        Look Inside
      </h2>
      <p className="mt-1.5 font-heading text-[14px] font-bold leading-tight text-brand md:text-[16px]" data-id="element-122" data-mp="zs16o9hlbl3j">
        Explore the Complete Speech Therapy Activities Bundle™
      </p>
      <p className="mx-auto mt-1.5 max-w-[580px] text-[13px] leading-[1.35] text-ink md:text-[14px]" data-id="element-123" data-mp="2b7put46kyq5x">
        Take a closer look at the articulation exercises, receptive and expressive language activities, social
        communication resources, printable therapy cards, games, home practice materials, and professional tracking
        forms included in the collection. Each resource is organized to help you find activities that match specific
        therapy goals.
      </p>

      <div className="relative mx-auto mt-3 max-w-[520px]" data-id="element-124" data-mp="1idc7trp6l65q">
        <div className="overflow-hidden rounded-md border border-line bg-white shadow-soft" data-id="element-125" data-mp="1dlki1jdun4gn">
          <AnimatePresence mode="wait" initial={false} data-id="element-126" data-mp="18mhb1teb6o61">
            <motion.a key={index} href={OFFER_ANCHOR} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.2} onDragStart={() => dragged.current = true} onDragEnd={(_, info) => {
            if (info.offset.x < -50) go(1);else if (info.offset.x > 50) go(-1);
            setTimeout(() => dragged.current = false, 0);
          }} onClick={e => dragged.current && e.preventDefault()} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: 'easeOut'
          }} className="flex aspect-[4/5] w-full cursor-grab items-center justify-center active:cursor-grabbing" aria-label={`Preview ${index + 1}: ${slide.caption}`} data-id="element-127" data-mp="18n0tdb7vfekl">
              {slide.image ? <img src={slide.image} alt={slide.caption} className="h-full w-full object-contain" draggable={false} data-id="element-128" data-mp="tzsg84v04z5z" /> : <span className="px-8 text-center" data-id="element-129" data-mp="yxkfxl1w1pkq">
                  <ImageIcon className="mx-auto h-9 w-9 text-brand/60" aria-hidden data-id="element-130" data-mp="1mog50aeym6oa" />
                  <span className="mt-2 block font-heading text-[14px] font-extrabold uppercase text-navy" data-id="element-131" data-mp="1mmmuul5514bj">
                    Preview {index + 1}
                  </span>
                  <span className="mt-1 block text-[12px] text-ink/70" data-id="element-132" data-mp="3c40le4u35cod">PDF preview image coming soon</span>
                </span>}
            </motion.a>
          </AnimatePresence>
        </div>
        <button type="button" onClick={() => go(-1)} aria-label="Previous preview" className="absolute left-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-white text-navy shadow-soft transition-colors duration-150 hover:text-brand" data-id="element-133" data-mp="3lulfpg2q7v1h">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-134" data-mp="3275mvlxtbca3" />
        </button>
        <button type="button" onClick={() => go(1)} aria-label="Next preview" className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-white text-navy shadow-soft transition-colors duration-150 hover:text-brand" data-id="element-135" data-mp="328qilevv519j">
          <ChevronRightIcon className="h-5 w-5" data-id="element-136" data-mp="18q17td3iyg28" />
        </button>
      </div>
      <p className="mx-auto mt-2 max-w-[560px] text-[13px] leading-[1.35] text-ink" data-id="element-137" data-mp="18s48qs67ttlq">{slide.caption}</p>
      <div className="mt-2 flex justify-center gap-1.5" role="tablist" aria-label="Choose preview" data-id="element-138" data-mp="1ct69jdfs6dpt">
        {previews.map((p, i) => <button key={p.caption} type="button" onClick={() => setIndex(i)} aria-label={`Show preview ${i + 1}`} aria-selected={i === index} role="tab" className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-5 bg-navy' : 'w-2 bg-line'}`} data-id="element-139" data-mp="1mpsu014732rb" data-mpi={i} />)}
      </div>
    </section>;
}